import iMISFetch from "@/utils/iMISFetch";
import { IQA_PRODUCTS, QUERY_ENDPOINT } from "@/store/constants";
import type { Product } from "@/store/types";

/**
 * GET /api/query?queryname=$/ASI/Store/AGDStoreProductList
 *
 * Optionally filtered by `category` and/or `product` (from the page URL params).
 * These extra params are appended to the query name with the legacy `&`
 * convention (`$/ASI/Foo&category=GD`), which iMISFetch splits into real URL
 * params.
 *
 * Returns [] on a successful-but-empty response; throws on network/5xx.
 */
export async function fetchProducts(
  filters: { category?: string | null; product?: string | null } = {}
): Promise<Product[]> {
  let query = IQA_PRODUCTS;
  if (filters.category) query += "&category=" + encodeURIComponent(filters.category);
  if (filters.product) query += "&product=" + encodeURIComponent(filters.product);

  const result = await iMISFetch<Product>(QUERY_ENDPOINT, { query, limit: 0 });
  if (!result.success) {
    throw new Error(`fetchProducts failed: ${result.message || "unknown error"}`);
  }
  return Array.isArray(result.data) ? (result.data as Product[]) : [];
}
